<mat-toolbar fxLayout  class="fx-jc-between fx-ai-center"[ngStyle]="{ height: 'auto' }">
  <div  class="fx-flex-72">
    <button mat-button
            [disabled]="!refreshButton"
            (click)="handleRefresh()">
      <mat-icon>
        refresh
      </mat-icon>
      &nbsp;
      <span [ngClass]="'mdc-button__label'">
        REFRESH
      </span>
    </button>
    <button mat-button
            [disabled]="!refreshButton"
            (click)="createFolder()">
      <mat-icon>
        create_new_folder
      </mat-icon>
      &nbsp; CREATE FOLDER
    </button>
    <button mat-button
            [disabled]="!refreshButton || files.length <= 1"
            (click)="openFileSearch()">
      <mat-icon>
        search
      </mat-icon>
      &nbsp; SEARCH
    </button>
  </div>
</mat-toolbar>
